import { Inject, Injectable } from '@angular/core';
import { HttpResponse } from '@angular/common/http';
import { isNil, omit } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

import { $frontendTypes } from './PalletTransactions.frontend.types'

@Injectable({ providedIn: 'root' })
export class PalletTransactions_pallet_inventory_add_or_deductService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  async run(inParams: { project_id?: number, pallet_class_id?: number, amount?: number }): Promise<{ success?: boolean, exceptions?: string, id?: number }> 
  {
    let url = `${environment.backendUrl}api/PalletTransactions/functions/pallet_inventory_add_or_deduct`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }

}

